// Indian numbering formatters
export function formatINR(value, opts = {}) {
    if (value === null || value === undefined || isNaN(value)) return '₹0';
    const n = Number(value);
    const compact = opts.compact !== false;
    if (compact) {
        if (Math.abs(n) >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
        if (Math.abs(n) >= 1e5) return `₹${(n / 1e5).toFixed(2)} L`;
        if (Math.abs(n) >= 1e3) return `₹${(n / 1e3).toFixed(1)} K`;
    }
    return `₹${n.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
}

export function formatINRFull(value) {
    if (value === null || value === undefined || isNaN(value)) return '₹0';
    return `₹${Number(value).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
}

export function formatNumber(value) {
    if (value === null || value === undefined) return '0';
    return Number(value).toLocaleString('en-IN');
}

export function formatDate(iso) {
    if (!iso) return '—';
    try {
        const d = new Date(iso);
        return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch {
        return iso;
    }
}

export function stageColor(stage) {
    const map = {
        'Lead Identified': 'bg-slate-100 text-slate-700 border-slate-300',
        'Pitching Services': 'bg-blue-950 text-blue-300 border-blue-900',
        'Qualifying Deal': 'bg-indigo-950 text-indigo-300 border-indigo-900',
        'Sending Proposal': 'bg-amber-950 text-amber-300 border-amber-900',
        'Negotiation': 'bg-orange-950 text-orange-300 border-orange-900',
        'Closure - Won': 'bg-emerald-950 text-emerald-300 border-emerald-900',
        'Closure - Lost': 'bg-red-950 text-red-300 border-red-900',
    };
    return map[stage] || 'bg-slate-100 text-slate-700 border-slate-300';
}

export function priorityColor(p) {
    if (p === 'High') return 'text-[#FF453A]';
    if (p === 'Medium') return 'text-[#FF9F0A]';
    return 'text-[#888]';
}
